export const fixLineString = (coordinates: Array<[number, number]>) => {
  let prevLng = 0;
  const result = coordinates.map((item: [number, number]) => {
    let lng = item[0];
    lng += lng - prevLng > 180 ? -360 : prevLng - lng > 180 ? 360 : 0;
    prevLng = lng;
    item[0] = lng;
    return item;
  });
  return result;
};
